import type { ChatbotState } from "@/types";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const initialState: ChatbotState = {
  isOpen: false,
  userDefaultQuery: [],
};

const ChatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setUserDefaultQuery: (state, action: PayloadAction<string[]>) => {
      state.userDefaultQuery = action.payload;
    },
  },
});

export const { setIsOpen, setUserDefaultQuery } = ChatbotSlice.actions;

export default ChatbotSlice.reducer;
